import type { CrmEnrichmentJobObject, CrmEnrichmentJobPriceDto, CrmProvider } from "../../types/types";

import { CRM_ENRICHMENT_BASE_QUERY_KEY } from "./const";
import type { ICrmEnrichmentQueryKeyFactory } from "./types";

export const createCrmEnrichmentQueryKeys = (crmProvider: CrmProvider): ICrmEnrichmentQueryKeyFactory => {
    const baseKeys = {
        all: () => [CRM_ENRICHMENT_BASE_QUERY_KEY, crmProvider] as const,
    };

    return {
        all: baseKeys.all,

        settings: () => [...baseKeys.all(), "settings"] as const,

        jobs: () => [...baseKeys.all(), "jobs"] as const,

        job: (id: string) => [...baseKeys.all(), "jobs", id] as const,

        price: (object: CrmEnrichmentJobObject) => [...baseKeys.all(), "jobs", object] as const,

        estimatedPrice: (fields: CrmEnrichmentJobPriceDto) => [...baseKeys.all(), "estimated-price", fields] as const,

        jobRunHistory: (jobId: string, page: number, pageSize: number) =>
            [...baseKeys.all(), "jobs", jobId, "run-history", page, pageSize] as const,
    };
};
